import type { TableData } from '@/types';
import TableRow from '@/components/tables/DataTable/TableRow';

interface TableBodyProps {
  data: TableData[];
  renderRow?: (item: TableData) => React.ReactNode;
}

/**
 * This component is used to display the table body.
 * @param data - The data to display.
 * @param renderRow - Optional custom row renderer. When provided, replaces the default row rendering.
 * @returns The table body component.
 */
const TableBody = ({ data, renderRow: customRenderRow }: TableBodyProps) => {
  return (
    <tbody>
      {data.map((item) =>
        customRenderRow ? customRenderRow(item) : <TableRow key={item.id} item={item} />,
      )}
    </tbody>
  );
};

export default TableBody;
